import { render, staticRenderFns } from "./VisitorRoutes.vue?vue&type=template&id=146bc64c&"
import script from "./VisitorRoutes.vue?vue&type=script&lang=js&"
export * from "./VisitorRoutes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports